export const STICKY_NAVBAR = 'sticky-navbar';
